import CryptoJS from 'crypto-js';

// Encrypt the data and pass it to the header while calling ws
export const ciphertext = CryptoJS.AES.encrypt('ohc279202410396', 'mokavmoemr100').toString();
export const headerData = {
  'Content-Type': 'application/json',
  // 'Authorization': 'Bearer your_token',  // Example of an authorization header
  'Custom-Header': ciphertext,       // Any custom header
};

/**
|--------------------------------------------------
| Check empty or undefined
|--------------------------------------------------
*/
export const checkEmpty = item => {
  if (item === undefined || item === null || item === "" || item === " ") {
    return true;
  }
  return false;
};

export const formatDate = date => {
  if (date) {
    const dateString = date.toDateString(),
      year = dateString.slice(11, 16),
      month = dateString.slice(4, 7),
      day = dateString.slice(8, 10),
      formattedDate = day + "-" + month + "-" + year;
    return formattedDate;
  }
};

export const formatTime = time => {
  if (time) {
    const timeString = time.toString();
    let hours = timeString.slice(16, 18), timeRange = "", formattedTime = "";
    if (hours >= 12) {
      timeRange = getTimeFormat(hours);
      formattedTime = timeRange + '.' + timeString.slice(19, 21) + '.00 PM';
    } else {
      timeRange = getTimeFormat(hours);
      formattedTime = timeRange + '.' + timeString.slice(19, 21) + '.00 AM';
    }

    return formattedTime;
  }
};

export const getTimeFormat = tFormat => {
  switch (tFormat.toString()) {
    case "00":
      return "12";
    case "13":
      return "01";
    case "14":
      return "02";
    case "15":
      return "03";
    case "16":
      return "04";
    case "17":
      return "05";
    case "18":
      return "06";
    case "19":
      return "07";
    case "20":
      return "08";
    case "21":
      return "09";
    case "22":
      return "10";
    case "23":
      return "11";
    case "24":
      return "12";
    default:
      return tFormat;
  }
}
